import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = {
  class: "grid-item-chunk-image"
};
const _hoisted_3 = {
  key: 0,
  class: "grid-item-chunk-badge"
};
const _hoisted_4 = {
  alt: "NO_DATA_IMAGE"
};
const _hoisted_5 = {
  alt: "NO_DATA_IMAGE"
};
const _hoisted_6 = {
  class: "grid-item-chunk-title"
};
import 'swiper/css/pagination';
import { computed, watch, shallowRef, onMounted } from 'vue';
import { Pagination } from 'swiper';
import { jumpInteractionType, deepClone, imageCutEdgeAndSetSize } from '@/utils/common';
import Carousel from '@/components/carousel/Carousel.vue';
import { useLess } from '@/models/hooks';
import { FILL_TYPE } from '@/configs/views/landingPage.js';
import imageLink from '@/configs/imageLink';
import { useRoute, useRouter } from 'vue-router';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents } from '@/configs/awsRumConfig';
const GRID_COLUMN_NUM = 5;
const GRID_ITEM_ROW2 = 'grid-item-row2';
const IS_GRID_BORDER_SHOWED = false;
export default {
  __name: 'Shortcut',
  props: {
    properties: {
      type: Object,
      require: true,
      default: () => ({})
    }
  },
  setup(__props) {
    const props = __props;
    useLess('views/landingPage/shortcut/Shortcut.less');
    const modulesCarousel = [Pagination];
    const shortcutData = shallowRef({});
    const route = useRoute();
    const router = useRouter();
    const NUMBER_ROWS_TYPE = {
      ONE: 5,
      TWO: 10
    };
    const wrapperStyle = computed(() => ({
      marginBottom: `${shortcutData.value.bottomSpacing}px`,
      backgroundColor: shortcutData.value.fillType === FILL_TYPE.SOLID_COLOR ? shortcutData.value.fillBackgroundColor : '',
      backgroundImage: shortcutData.value.fillType === FILL_TYPE.PICURL ? `url(${shortcutData.value.fillBackgroundColor})` : ''
    }));
    const onClickGridItem = slideItem => {
      jumpInteractionType(slideItem, router);
    };
    const toDecomposeArr = (arr, num) => arr.reduce((total, currentValue, currentIndex) => {
      if (currentIndex % num === 0) total.push([]);
      total[Math.floor(currentIndex / num)].push(currentValue);
      return total;
    }, []);
    watch(() => props.properties, properties => {
      if (!properties) return;
      // Deep copy, Prevent triggering watch after modification
      const propertiesData = deepClone(properties);
      if (propertiesData !== null && propertiesData !== void 0 && propertiesData.numberRows && propertiesData.interactionTypeInfo.length) {
        propertiesData.interactionTypeInfo = toDecomposeArr(propertiesData.interactionTypeInfo, NUMBER_ROWS_TYPE[propertiesData.numberRows]);
        if (propertiesData.numberRows !== NUMBER_ROWS_TYPE.ONE) {
          propertiesData.interactionTypeInfo.forEach(item => {
            item.forEach((interaction, index) => {
              if (index >= GRID_COLUMN_NUM) {
                interaction.className = GRID_ITEM_ROW2;
              }
            });
          });
        }
      } else {
        propertiesData.interactionTypeInfo = [];
      }
      if (!(propertiesData !== null && propertiesData !== void 0 && propertiesData.textColor)) propertiesData.textColor = '';
      shortcutData.value = propertiesData;
    }, {
      immediate: true
    });
    onMounted(() => {
      const recordParams = {
        pageName: route.name
      };
      awsRumHandler.recordClickEvent({
        ...clickEvents.landingPage.shortcutWidget,
        ...recordParams
      });
    });
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_grid_item = _resolveComponent("van-grid-item");
      const _component_van_grid = _resolveComponent("van-grid");
      const _directive_reload_img = _resolveDirective("reload-img");
      return shortcutData.value.isShow == 'DISPLAY' && shortcutData.value.interactionTypeInfo.length ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "shortcut-nav-wrapper",
        style: _normalizeStyle(wrapperStyle.value)
      }, [_createVNode(Carousel, {
        modulesCarousel: modulesCarousel,
        slideData: shortcutData.value.interactionTypeInfo,
        pagination: {
          clickable: true
        }
      }, {
        content: _withCtx(({
          slide
        }) => [_createVNode(_component_van_grid, {
          square: "",
          border: IS_GRID_BORDER_SHOWED,
          "column-num": GRID_COLUMN_NUM
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slide, (slideItem, slideIndex) => {
            return _openBlock(), _createBlock(_component_van_grid_item, {
              key: slideIndex,
              class: _normalizeClass(slideItem.className)
            }, {
              default: _withCtx(() => [_createElementVNode("div", {
                class: "grid-item-chunk",
                onClick: $event => onClickGridItem(slideItem)
              }, [_createElementVNode("div", _hoisted_2, [slideItem !== null && slideItem !== void 0 && slideItem.subscriptUrl ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_van_image, {
                fit: "contain",
                src: slideItem.subscriptUrl,
                alt: ""
              }, null, 8, ["src"])])) : _createCommentVNode("", true), _createVNode(_component_van_image, {
                fit: "contain",
                src: _unref(imageCutEdgeAndSetSize)(slideItem.navigationPicUrl)
              }, {
                loading: _withCtx(() => [_withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [[_directive_reload_img, _unref(imageCutEdgeAndSetSize)(_unref(imageLink).NO_DATA_IMAGE)]])]),
                error: _withCtx(() => [_withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [[_directive_reload_img, _unref(imageCutEdgeAndSetSize)(_unref(imageLink).NO_DATA_IMAGE)]])]),
                _: 2
              }, 1032, ["src"])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: shortcutData.value.textColor
                })
              }, _toDisplayString(slideItem.navigationName), 5)])], 8, _hoisted_1)]),
              _: 2
            }, 1032, ["class"]);
          }), 128))]),
          _: 2
        }, 1024)]),
        _: 1
      }, 8, ["slideData"])], 4)) : _createCommentVNode("", true);
    };
  }
};